// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_8QL-5I","container":"_1wCxWY","content":"iWq2ib","image":"QHHf6p"};